// extracted by mini-css-extract-plugin
export default {"heading":"Courses_heading__I8FlX","lpLoader":"Courses_lpLoader__+H721"};